// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2H7kU","list":"styles_list__2Mlk2"};